import React, {useEffect} from 'react'
import {observer} from "mobx-react"
import './sass/MobileTopCircle.sass'
import NavbarStore from "../../Bars/NavBar/store/NavbarStore";

const MobileTopCircle = observer(() => {
    useEffect(() => {

    }, [])
    return (
        <div className={'circle'}>
            <div onClick={() => {
                NavbarStore.setShowInMobile(true)
            }} className={'menu-burger-button'}>
                <i className="fas fa-bars"/>
            </div>
        </div>
    )
})
export default MobileTopCircle 